/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Not_Specified16Inputs */

const en__field_enum_tuda_not_specified16 = /** @type {(inputs: _Field_Enum_Tuda_Not_Specified16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`not specfied`)
};

const de__field_enum_tuda_not_specified16 = /** @type {(inputs: _Field_Enum_Tuda_Not_Specified16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ohne Angabe`)
};

/**
* | output |
* | --- |
* | "not specfied" |
*
* @param {_Field_Enum_Tuda_Not_Specified16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_not_specified16 = /** @type {((inputs?: _Field_Enum_Tuda_Not_Specified16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Not_Specified16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_not_specified16(inputs)
	return de__field_enum_tuda_not_specified16(inputs)
});
export { _field_enum_tuda_not_specified16 as "_field_enum_TUDA_NOT_SPECIFIED" }